import pb from '../lib/pocketbase';

export async function getProductos(page, perPage) {
  return await pb.collection('producto').getList(page, perPage, {
    sort: '-created', // Ordenar por fecha de creación descendente
    $autoCancel: false,
    expand: 'parent' // Expandir relación con producto padre
  });
}

export async function createProducto(producto) {
  return await pb.collection('producto').create(producto);
}

export async function updateProducto(id, producto) {
  return await pb.collection('producto').update(id, producto);
}

export async function deleteProducto(id) {
  return await pb.collection('producto').delete(id);
}
